import request from './request';

// 定义接口响应类型
interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
  code?: number;
}

// 绑定用户关系
export async function bindUserRelation(referrerUserCode: string): Promise<ApiResponse> {
  return request.post(`/apiservice/campaign/campaignReferRecord/downloadNotice`, {
    referrerUserCode
  });
} 